import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AppointmentWithUncreditedReservations, AppointmentWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAppointment(): UseMutationResult<
  AxiosResponse<AppointmentWithUncreditedReservations>,
  AxiosError<ErrorMessage>,
  AppointmentWrite
> {
  const queryClient = useQueryClient();

  const createAppointment = (
    appointment: AppointmentWrite,
  ): Promise<AxiosResponse<AppointmentWithUncreditedReservations>> => {
    return client.post('appointments/', appointment);
  };

  return useMutation(createAppointment, {
    onSuccess: () => {
      queryClient.invalidateQueries('appointments');
      queryClient.invalidateQueries('events');
    },
  });
}
